var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { properties } from '@debbie/cortex/dist/api';
import THEME from '../../theme';
import Modal from '../Modal';
import PlaceholderLoader from '../PlaceholderLoader';
import PerformedBy from '../performed-by/PerformedBy';
import PropertyData from './PropertyData';
const PropertyHistory = (props) => {
    const lang = useSelector((s) => s.lang);
    const [hist, setHist] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchPropertiesHist();
    }, []);
    const fetchPropertiesHist = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!loading) {
            setLoading(true);
            const hist = yield properties.historical(props.property.propRef, props.property.propRefId, props.property.handle);
            setLoading(false);
            setHist(hist);
        }
    });
    return (React.createElement(Modal, { header: lang.properties.historical, onToggle: props.onToggle, maxWidth: "500px" },
        loading ? (React.createElement(PlaceholderLoader, null)) : (hist.length === 0 && React.createElement("p", null, "No records yet.")),
        hist.map((histEntry) => (React.createElement(HistItem, null,
            histEntry.createdBy && (React.createElement(PerformedBy, { performedBy: histEntry.createdBy })),
            React.createElement("div", { style: {
                    padding: '0 10px',
                    flexGrow: 2,
                } },
                React.createElement(PropertyData, { property: histEntry })),
            React.createElement("small", null, moment(histEntry.createdAt).format(THEME.DATE_FORMAT_LONG)))))));
};
export default PropertyHistory;
const HistItem = styled.div `
  border-bottom: 1px solid lightgrey;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;

  small {
    float: right;
  }

  &:last-child {
    border-bottom: none;
  }
`;
//# sourceMappingURL=PropertyHistory.js.map